import type { AllRouteEndpoints } from "../routeTypes";
export const usersSubscriptionGroupsUpdateArchivedStateIdCacheKeys: AllRouteEndpoints[] = [
  "/users/subscription_groups_data",
];
